const IOS_USER_AGENT_PATTERN = /iPad|iPhone|iPod/i;
const ANDROID_USER_AGENT_PATTERN = /Android/i;

export const detectMobilePlatform = ({
  userAgent = '',
  platform = '',
  maxTouchPoints = 0,
} = {}) => {
  const normalizedUserAgent = String(userAgent || '');
  const normalizedPlatform = String(platform || '');
  const touchPoints = Number(maxTouchPoints) || 0;

  const isIOS =
    IOS_USER_AGENT_PATTERN.test(normalizedUserAgent) ||
    (normalizedPlatform === 'MacIntel' && touchPoints > 1);

  if (isIOS) {
    return 'ios';
  }

  if (ANDROID_USER_AGENT_PATTERN.test(normalizedUserAgent)) {
    return 'android';
  }

  return 'desktop';
};

export const detectCurrentMobilePlatform = () => {
  if (typeof navigator === 'undefined') {
    return 'desktop';
  }

  return detectMobilePlatform({
    userAgent: navigator.userAgent,
    platform: navigator.platform,
    maxTouchPoints: navigator.maxTouchPoints,
  });
};
